if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();

      if (this.classList.contains('disabled')) return;

      this.swatches = this.querySelector('.js-swatches');
      this.defaultMedia = this.querySelector('.js-media-default');
      this.cartDrawer = document.querySelector('cart-drawer');

      this.quickAdd = this.querySelector('[data-sk-quick-add]');
      this.quickAddToggle = this.querySelector('[data-sk-quick-add-toggle]');
      this.quickAddPanel = this.querySelector('[data-sk-quick-add-panel]');
      this.quickAddClose = this.querySelector('[data-sk-quick-add-close]');
      this.sizeBtns = this.quickAdd
        ? [...this.quickAdd.querySelectorAll('.js-btn-size')]
        : [];

      if (this.quickAddToggle && this.quickAddPanel) {
        this.quickAddToggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleQuickAdd();
        });

        this.quickAddClose?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.closeQuickAdd();
        });

        this.quickAddPanel.addEventListener('click', (event) => {
          if (!event.target.classList.contains('js-btn-size')) return;

          this.handleBtnSizeClick(event);
        });
      }

      document.addEventListener('click', (event) => {
        if (
          !this.quickAdd ||
          !this.quickAdd.classList.contains('is-open')
        ) {
          return;
        }

        if (!this.quickAdd.contains(event.target)) {
          this.closeQuickAdd();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeQuickAdd();
        }
      });

      if (this.swatches) {
        this.btnSwatches =
          this.swatches.querySelectorAll('.js-btn-swatch');

        this.swatches.addEventListener('click', (event) => {
          const variantId =
            event.target.getAttribute('data-variant');

          if (!variantId) return;

          const closestProductCardMedia =
            event.target
              .closest('.relative')
              ?.querySelector('.card-product__media');

          const closestProductCardContent =
            event.target
              .closest('card-product')
              ?.querySelector('.card-product__content');

          if (closestProductCardMedia) {
            const currentUrlMedia =
              closestProductCardMedia.href.split('?')[0];

            closestProductCardMedia.href =
              `${currentUrlMedia}?variant=${variantId}`;
          }

          if (closestProductCardContent) {
            const currentUrlContent =
              closestProductCardContent.href.split('?')[0];

            closestProductCardContent.href =
              `${currentUrlContent}?variant=${variantId}`;
          }
        });

        this.swatches.addEventListener('change', (event) => {
          this.querySelector('a.card-product__media')
            ?.classList.add('is-transitioning');

          const isBtnSwatch =
            event.target.classList.contains('js-btn-swatch');

          if (!isBtnSwatch) return;

          const btnSwatch = event.target;

          if (btnSwatch.classList.contains('is-active')) {
            return;
          }

          const btnSwatchColor =
            btnSwatch.dataset.colorHandle;

          const btnSwatchColorHyphenated =
            btnSwatchColor
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/-$/, '')
              .replace(/^-/, '');

          const activeBtnSwatch =
            this.swatches.querySelector(
              '.js-btn-swatch.is-active'
            );

          const currentVisibleMedia =
            this.querySelector(
              '[class*="js-media"].is-visible'
            );

          const newVisibleMedia =
            this.querySelector(
              `.js-media-${btnSwatchColorHyphenated}`
            );

          activeBtnSwatch?.classList.remove('is-active');
          btnSwatch.classList.add('is-active');

          if (newVisibleMedia) {
            currentVisibleMedia?.classList.remove(
              'is-visible'
            );

            newVisibleMedia.classList.add('is-visible');
          } else if (this.defaultMedia) {
            currentVisibleMedia?.classList.remove(
              'is-visible'
            );

            this.defaultMedia.classList.add(
              'is-visible'
            );
          }

          const sizeMessagesContainer =
            this.quickAddPanel?.querySelector(
              '.js-messages.is-visible'
            );

          sizeMessagesContainer?.classList.remove(
            'is-visible'
          );

          if (this.classList.contains('is-requesting')) {
            return;
          }

          this.toggleBtns();

          this.querySelector('a.card-product__media')
            ?.classList.remove('is-transitioning');

          const updateAvailableSizes = async () => {
            try {
              const product = await this.getProduct();

              const matchingColorVariants =
                product.variants.filter((variant) =>
                  variant.options.includes(btnSwatchColor)
                );

              this.sizeBtns.forEach((sizeBtn) => {
                const size = sizeBtn.dataset.size;

                let matchingSizeVariant;

                if (matchingColorVariants.length === 1) {
                  matchingSizeVariant =
                    matchingColorVariants.find(
                      (matchingColorVariant) =>
                        product.variants.some(
                          (variant) =>
                            variant.options.includes(size) &&
                            variant.options.some((opt) =>
                              matchingColorVariant.options.includes(
                                opt
                              )
                            )
                        )
                    );
                } else {
                  matchingSizeVariant =
                    matchingColorVariants.find(
                      (matchingColorVariant) =>
                        matchingColorVariant.options.includes(
                          size
                        )
                    );
                }

                if (
                  matchingSizeVariant &&
                  matchingSizeVariant.available
                ) {
                  sizeBtn.setAttribute(
                    'aria-disabled',
                    'false'
                  );

                  sizeBtn.classList.remove('is-disabled');

                  sizeBtn.setAttribute(
                    'data-variantid',
                    matchingSizeVariant.id
                  );

                  sizeBtn.setAttribute(
                    'title',
                    matchingSizeVariant.title
                  );

                  return;
                }

                sizeBtn.setAttribute(
                  'aria-disabled',
                  'true'
                );

                sizeBtn.classList.add('is-disabled');
              });
            } catch (error) {
              console.error(error);
            } finally {
              this.toggleBtns();
            }
          };

          updateAvailableSizes();
        });
      }
    }

    async getProduct() {
      const response = await fetch(
        `${window.Shopify.routes.root}products/${this.dataset.handle}.js`
      );

      return await response.json();
    }

    openQuickAdd() {
      if (!this.quickAdd || !this.quickAddPanel) {
        return;
      }

      document
        .querySelectorAll(
          'card-product [data-sk-quick-add].is-open'
        )
        .forEach((instance) => {
          if (instance !== this.quickAdd) {
            instance.classList.remove('is-open');

            const panel =
              instance.querySelector(
                '[data-sk-quick-add-panel]'
              );

            const toggle =
              instance.querySelector(
                '[data-sk-quick-add-toggle]'
              );

            if (panel) {
              panel.hidden = true;
            }

            if (toggle) {
              toggle.setAttribute(
                'aria-expanded',
                'false'
              );
            }
          }
        });

      this.quickAdd.classList.add('is-open');

      this.quickAddPanel.hidden = false;

      this.quickAddToggle?.setAttribute(
        'aria-expanded',
        'true'
      );
    }

    closeQuickAdd() {
      if (!this.quickAdd || !this.quickAddPanel) {
        return;
      }

      this.quickAdd.classList.remove('is-open');

      this.quickAddPanel.hidden = true;

      this.quickAddToggle?.setAttribute(
        'aria-expanded',
        'false'
      );
    }

    toggleQuickAdd() {
      if (!this.quickAdd) return;

      if (this.quickAdd.classList.contains('is-open')) {
        this.closeQuickAdd();
      } else {
        this.openQuickAdd();
      }
    }

    toggleBtns() {
      this.classList.toggle('is-requesting');

      this.btnSwatches?.forEach((btnSwatch) =>
        btnSwatch.toggleAttribute('disabled')
      );

      this.quickAdd?.classList.toggle('is-loading');
    }

    handleBtnSizeClick(event) {
      const btnSize =
        event.target.closest('.js-btn-size');

      if (
        !btnSize ||
        btnSize.classList.contains('is-disabled') ||
        this.classList.contains('is-requesting')
      ) {
        return;
      }

      const btnSwatchActive =
        this.querySelector(
          '.js-btn-swatch.is-active'
        );

      const selectedSize =
        btnSize.dataset.size;

      const selectedColor =
        btnSwatchActive?.dataset.color;

      const selectedVariantId =
        btnSize.dataset.variantid
          ? btnSize.dataset.variantid
          : undefined;

      const targetPanel =
        btnSize.closest(
          '[data-sk-quick-add-panel]'
        );

      const sizeMessagesContainer =
        targetPanel?.querySelector(
          '.js-messages'
        );

      const sizeMessageSuccess =
        targetPanel?.querySelector(
          '.js-success-message'
        );

      const sizeMessageError =
        targetPanel?.querySelector(
          '.js-error-message'
        );

      this.toggleBtns();

      const addProductToCart = async () => {
        try {
          const product = await this.getProduct();

          const matchingVariant =
            product.variants.find((variant) => {
              if (selectedVariantId) {
                return (
                  String(variant.id) ===
                  String(selectedVariantId)
                );
              }

              const matchesSize =
                selectedSize
                  ? variant.options.includes(
                      selectedSize
                    )
                  : true;

              const matchesColor =
                btnSwatchActive
                  ? variant.options.includes(
                      selectedColor
                    )
                  : true;

              return (
                matchesSize &&
                matchesColor
              );
            });

          if (!matchingVariant) {
            throw new Error(
              'Uygun varyant bulunamadı.'
            );
          }

          if (!matchingVariant.available) {
            throw new Error(
              'Seçilen beden stokta yok.'
            );
          }

          const formData =
            new FormData();

          formData.append(
            'id',
            matchingVariant.id
          );

          formData.append(
            'quantity',
            1
          );

          if (
            this.hasAttribute(
              'data-has-pre-order'
            )
          ) {
            formData.append(
              'properties[Pre-order]',
              '✓'
            );
          }

          let sectionsToRender = [];

          if (
            this.cartDrawer &&
            typeof this.cartDrawer
              .getSectionsToRender ===
              'function'
          ) {
            sectionsToRender =
              this.cartDrawer
                .getSectionsToRender()
                ?.map(
                  (section) =>
                    section.section
                ) || [];
          } else {
            const mainCartItems =
              document.getElementById(
                'main-cart-items'
              );

            if (
              mainCartItems?.dataset?.id
            ) {
              sectionsToRender.push(
                mainCartItems.dataset.id
              );
            }

            sectionsToRender.push(
              'cart-counter'
            );
          }

          formData.append(
            'sections',
            sectionsToRender
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          const config =
            fetchConfig('javascript');

          config.headers[
            'X-Requested-With'
          ] = 'XMLHttpRequest';

          delete config.headers[
            'Content-Type'
          ];

          config.body = formData;

          const addToCartResponse =
            await fetch(
              `${routes.cart_add_url}`,
              config
            );

          const addToCartData =
            await addToCartResponse.json();

          if (!addToCartResponse.ok) {
            throw new Error(
              addToCartData.description ||
                'Sepete eklenemedi.'
            );
          }

          sizeMessageSuccess
            ?.classList.remove('hidden');

          sizeMessageError
            ?.classList.add('hidden');

          if (
            this.cartDrawer &&
            typeof this.cartDrawer
              .renderContents ===
              'function'
          ) {
            this.cartDrawer.renderContents(
              addToCartData,
              true
            );
          }

          this.closeQuickAdd();
        } catch (error) {
          const errorTextEl =
            sizeMessageError?.querySelector(
              '[data-text]'
            );

          sizeMessageSuccess
            ?.classList.add('hidden');

          sizeMessageError
            ?.classList.remove('hidden');

          if (errorTextEl) {
            errorTextEl.textContent =
              error.message;
          }
        } finally {
          this.toggleBtns();

          if (sizeMessagesContainer) {
            sizeMessagesContainer.classList.add(
              'is-visible'
            );

            setTimeout(() => {
              sizeMessagesContainer.classList.remove(
                'is-visible'
              );
            }, 3000);
          }
        }
      };

      addProductToCart();
    }
  }

  customElements.define(
    'card-product',
    CardProduct
  );
}